<template>
  <div class="floating" :class="{'floating-tools': floatingType === 'tools'}">
    <slot name="content" />
  </div>
</template>

<script>
export default {
  props: {
    floatingType: {
      type: String,
      required: false
    }
  }
}
</script>

<style lang="sass" scoped>
.floating
  width: 100%
  padding: 15px 0
  position: fixed
  bottom: 0
  left: 0
  z-index: 3
  &:not(.floating-tools)
    background-color: rgba(255, 255, 255, .7)
.btn-wrapper
  padding-bottom: constant(safe-area-inset-bottom)
  padding-bottom: env(safe-area-inset-bottom)
</style>
